import _regeneratorRuntime from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { KmsKeyringClass, getClient, limitRegions, excludeRegions, cacheClients } from '@aws-crypto/kms-keyring';
import { immutableClass, importForWebCryptoEncryptionMaterial, importForWebCryptoDecryptionMaterial, KeyringWebCrypto } from '@aws-crypto/material-management-browser';
import { KMS } from 'aws-sdk';
var getKmsClient = getClient(KMS, {
  customUserAgent: 'AwsEncryptionSdkJavascriptBrowser/2.0.0'
});
var cacheKmsClients = cacheClients(getKmsClient);
export var KmsKeyringBrowser = /*#__PURE__*/function (_KmsKeyringClass) {
  _inherits(KmsKeyringBrowser, _KmsKeyringClass);

  var _super = _createSuper(KmsKeyringBrowser);

  function KmsKeyringBrowser() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$clientProvider = _ref.clientProvider,
        clientProvider = _ref$clientProvider === void 0 ? cacheKmsClients : _ref$clientProvider,
        keyIds = _ref.keyIds,
        generatorKeyId = _ref.generatorKeyId,
        grantTokens = _ref.grantTokens,
        discovery = _ref.discovery;

    _classCallCheck(this, KmsKeyringBrowser);

    return _super.call(this, {
      clientProvider: clientProvider,
      keyIds: keyIds,
      generatorKeyId: generatorKeyId,
      grantTokens: grantTokens,
      discovery: discovery
    });
  }

  _createClass(KmsKeyringBrowser, [{
    key: "_onEncrypt",
    value: function () {
      var _onEncrypt2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(material) {
        var _material;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _get(_getPrototypeOf(KmsKeyringBrowser.prototype), "_onEncrypt", this).call(this, material);

              case 2:
                _material = _context.sent;
                return _context.abrupt("return", importForWebCryptoEncryptionMaterial(_material));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _onEncrypt(_x) {
        return _onEncrypt2.apply(this, arguments);
      }

      return _onEncrypt;
    }()
  }, {
    key: "_onDecrypt",
    value: function () {
      var _onDecrypt2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(material, encryptedDataKeys) {
        var _material;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _get(_getPrototypeOf(KmsKeyringBrowser.prototype), "_onDecrypt", this).call(this, material, encryptedDataKeys);

              case 2:
                _material = _context2.sent;
                return _context2.abrupt("return", importForWebCryptoDecryptionMaterial(_material));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _onDecrypt(_x2, _x3) {
        return _onDecrypt2.apply(this, arguments);
      }

      return _onDecrypt;
    }()
  }]);

  return KmsKeyringBrowser;
}(KmsKeyringClass(KeyringWebCrypto));
immutableClass(KmsKeyringBrowser);
export { getClient, cacheKmsClients, limitRegions, excludeRegions, cacheClients, KMS };